import { Component, Fragment, ReactNode } from 'react';
import { NavLink } from 'react-router';

export default class Sidebar extends Component {
  constructor(
    readonly props: Readonly<{
      children?: ReactNode;
      navigate?: any;
      currentUser: any;
      initialExpanded?: boolean;
      onChangeSidebar?: (expanded: boolean) => void;
    }>,
  ) {
    super(props);

    this.state = {
      expanded: false,
    };
  }

  state: Readonly<{
    expanded: boolean;
  }>;

  isActive(path: string) {
    return window.location.href.includes(path);
  }

  sizeClasses() {
    return this.state.expanded
      ? 'col-md-2 col-lg-2'
      : 'col-md-1 col-lg-1 sidebar-collapsed';
  }

  getTolltips() {
    return [].slice.call(
      document.querySelectorAll('[data-bs-toggle="tooltip"]'),
    );
  }

  componentWillUnmount(): void {
    const tooltipTriggerList = this.getTolltips();

    tooltipTriggerList.map(function (tooltipTriggerEl: any) {
      const _tool = new (window as any).bootstrap.Tooltip(tooltipTriggerEl);
      const _el = _tool.getTipElement();

      _tool.hide();
      // _tool.dispose();

      _el.remove();

      return _tool;
    });
  }

  componentDidMount(): void {
    setTimeout(() => {
      if (!this.state.expanded) {
        const tooltipTriggerList = this.getTolltips();

        tooltipTriggerList.map(function (tooltipTriggerEl: any) {
          return new (window as any).bootstrap.Tooltip(tooltipTriggerEl);
        });
      }
    }, 500);
  }

  changeTooltip(enable: boolean) {
    const tooltipTriggerList = this.getTolltips();

    tooltipTriggerList.map(function (tooltipTriggerEl: any) {
      const _tool = new (window as any).bootstrap.Tooltip(tooltipTriggerEl);
      if (enable) {
        _tool.enable();
      } else {
        _tool.disable();
      }

      return _tool;
    });
  }

  setExpanded() {
    const _val = !this.state.expanded;
    this.setState({ expanded: _val });

    this.changeTooltip(!_val);

    if (this.props.onChangeSidebar) {
      this.props.onChangeSidebar(_val);
    }
  }

  render(): ReactNode {
    return (
      <nav
        id="sidebarMenu"
        className={`${this.sizeClasses()} d-md-block bg-light sidebar collapse`}
      >
        <div className="position-sticky pt-3">
          <ul className="nav flex-column">
            <Fragment>
              <li className="nav-item">
                <NavLink
                  to="/calendar"
                  className={`nav-link ${this.isActive('/calendar') ? 'active' : ''}`}
                  aria-current="page"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Agenda"
                >
                  <i className="bi bi-calendar pe-none me-2"></i>
                  {this.state.expanded ? 'Agenda' : ''}
                </NavLink>
              </li>
              {this.props.currentUser.role === 'admin' && (
                <li className="nav-item">
                  <NavLink
                    to="/day-events"
                    className={`nav-link ${this.isActive('/day-events') ? 'active' : ''}`}
                    aria-current="page"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Eventos do Dia"
                  >
                    <i className="bi bi-card-checklist pe-none me-2"></i>
                    {this.state.expanded ? 'Eventos do Dia' : ''}
                  </NavLink>
                </li>
              )}
              {this.props.currentUser.role === 'admin' && (
                <li className="nav-item">
                  <NavLink
                    to="/people"
                    className={`nav-link ${this.isActive('/people') ? 'active' : ''}`}
                    aria-current="page"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Pessoas"
                  >
                    <i className="bi bi-people pe-none me-2"></i>
                    {this.state.expanded ? 'Pessoas' : ''}
                  </NavLink>
                </li>
              )}

              <li className="nav-item">
                <NavLink
                  to="/reports"
                  className={`nav-link ${this.isActive('/reports') ? 'active' : ''}`}
                  aria-current="page"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Relatórios"
                >
                  <i className="bi bi-graph-up pe-none me-2"></i>
                  {this.state.expanded ? 'Relatórios' : ''}
                </NavLink>
              </li>

              {this.props.currentUser.role === 'admin' && (
                <li className="nav-item">
                  <NavLink
                    to="/cover-photos"
                    className={`nav-link ${this.isActive('/cover-photos') ? 'active' : ''}`}
                    aria-current="page"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Fotos de capa"
                  >
                    <i className="bi bi-camera pe-none me-2"></i>
                    {this.state.expanded ? 'Fotos de capa' : ''}
                  </NavLink>
                </li>
              )}
              {this.props.currentUser.role === 'admin' && (
                <li className="nav-item">
                  <NavLink
                    to="/google-reviews"
                    className={`nav-link ${this.isActive('/oogle-reviews') ? 'active' : ''}`}
                    aria-current="page"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Avaliações do Google"
                  >
                    <i className="bi bi-star pe-none me-2"></i>
                    {this.state.expanded ? 'Avaliações do Google' : ''}
                  </NavLink>
                </li>
              )}
              <li className="nav-item">
                <NavLink
                  to="/site-carousel"
                  className={`nav-link ${this.isActive('/site-carousel') ? 'active' : ''}`}
                  aria-current="page"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Fotos ao vivo"
                >
                  <i className="bi bi-highlights pe-none me-2"></i>
                  {this.state.expanded ? 'Fotos ao vivo' : ''}
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/incomes"
                  className={`nav-link ${this.isActive('/incomes') ? 'active' : ''}`}
                  aria-current="page"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Receitas"
                >
                  <i className="bi bi-cash-stack pe-none me-2"></i>
                  {this.state.expanded ? 'Receitas' : ''}
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/expenses"
                  className={`nav-link ${this.isActive('/expenses') ? 'active' : ''}`}
                  aria-current="page"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Despesas"
                >
                  <i className="bi bi-wallet2 pe-none me-2"></i>
                  {this.state.expanded ? 'Despesas' : ''}
                </NavLink>
              </li>

              {this.props.currentUser.role === 'admin' && (
                <li className="nav-item">
                  <NavLink
                    to="/google-calendar"
                    className={`nav-link ${this.isActive('/google-calendar') ? 'active' : ''}`}
                    aria-current="page"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Conectar ao Google Agenda"
                  >
                    <i className="bi bi-google pe-none me-2"></i>
                    {this.state.expanded ? 'Conectar ao Google Agenda' : ''}
                  </NavLink>
                </li>
              )}
              <li className="nav-item">
                <NavLink
                  to={`/people/${this.props.currentUser.id}/password`}
                  className={`nav-link ${this.isActive(`/people/${this.props.currentUser.id}/password`) ? 'active' : ''}`}
                  aria-current="page"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  title="Alterar senha"
                >
                  <i className="bi bi-key pe-none me-2"></i>
                  {this.state.expanded ? 'Alterar senha' : ''}
                </NavLink>
              </li>
            </Fragment>
          </ul>
        </div>
      </nav>
    );
  }
}
